"use client";

import React, { useEffect, useRef, useState } from "react";
import DOMPurify from "dompurify";

import styles from "./batch-updates.module.scss";
import utils from "@/utils";

function UpdatesCard({ update, isUnread }) {
  const [showMore, setShowMore] = useState(false);
  const { title, description, updatedAt } = update;
  const descRef = useRef();

  useEffect(() => {
    if (descRef.current) {
      descRef.current.innerHTML = DOMPurify.sanitize(
        utils.linkify(description)
      );
    }
  }, [description]);

  return (
    <article className={`${styles.card} ${isUnread ? styles.unreadCard : ""}`}>
      <header className={styles.header}>
        <h3>{title}</h3>
        <span className={styles.timeLabel}>
          {utils.timeDifference(new Date(updatedAt), new Date(), "")} ago
        </span>
      </header>
      <p
        ref={descRef}
        className={`${styles.description} ${showMore ? styles.showMore : ""}`}
      ></p>
      <span
        className={styles.readMoreBtn}
        onClick={() => setShowMore((prev) => !prev)}
      >
        Read {showMore ? "less" : "more"}
      </span>
    </article>
  );
}

export default UpdatesCard;
